import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function StarFullIcon(props) {
    return (
        <SvgIcon {...props}>
            <path clipRule="evenodd" d="M10.8873 2.76012C11.2829 1.74665 12.7171 1.74665 13.1127 2.76012L14.906 7.35433C15.0758 7.78923 15.4834 8.08536 15.9494 8.11242L20.873 8.3983C21.9591 8.46137 22.4023 9.8253 21.5606 10.5147L17.7455 13.64C17.3843 13.9358 17.2286 14.415 17.3469 14.8666L18.5965 19.6375C18.8721 20.6899 17.7119 21.5329 16.7961 20.9455L12.6449 18.2828C12.2519 18.0308 11.7481 18.0308 11.3551 18.2828L7.20388 20.9455C6.28812 21.5329 5.12789 20.6899 5.40354 19.6375L6.6531 14.8666C6.77139 14.415 6.61571 13.9358 6.25455 13.64L2.43937 10.5147C1.59775 9.8253 2.04092 8.46137 3.12704 8.3983L8.05056 8.11242C8.51664 8.08536 8.92423 7.78923 9.09399 7.35433L10.8873 2.76012Z" fillRule="evenodd" />
        </SvgIcon>
    );
}

export default StarFullIcon;
